import React from "react";
import "../assests/CSS/AboutComponent2.css";
import { aboutData2 } from "./data";

const AboutComponent2 = () => {
  return (
    <section className="about2-section">
      <div className="about2-row">
        <div className="about2-text vision-text">
          <h2>{aboutData2.vision.title}</h2>
          <p>{aboutData2.vision.description}</p>
        </div>
        <div className="about2-img vision-image">
          <img src={aboutData2.vision.image} alt="Vision" />
        </div>
      </div>

      <div className="about2-row mission-row">
        <div className="about2-img mission-image">
          <img src={aboutData2.mission.image} alt="Mission" />
        </div>
        <div className="about2-text mission-text">
          <h2 className="mission-title" >{aboutData2.mission.title}</h2>
          <p className="mission-desc">{aboutData2.mission.description}</p>
        </div>
      </div>

      <div className="about2-difference">
        {/* <h2>{aboutData2.difference.title}</h2> */}
        <h2>What Makes <span style={{ color: "#000", fontWeight: "bold" }}>Thhiya</span><span style={{ color: "red", fontSize: "2rem", paddingRight:"0.5rem" }}>.</span>Different</h2>
        <p>{aboutData2.difference.subtitle}</p>
        <h3>{aboutData2.difference.tagline}</h3>
        <div className="difference-list">
          {aboutData2.difference.points.map((point, index) => (
            <div className="difference-item" key={index}>
              <span className="blue-bar"></span>
              <p>{point}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutComponent2;
